import { render, staticRenderFns } from "./avatar_modal.vue?vue&type=template&id=c2bfb9b2"
import script from "./avatar_modal.vue?vue&type=script&lang=js"
export * from "./avatar_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports